export const OUTREACH_KEYS = {
  all: ['outreach'] as const,
  log: (userid: string | number) => [...OUTREACH_KEYS.all, 'log', String(userid)] as const,
  patientLastSeen: (userid: string | number) => [...OUTREACH_KEYS.all, 'patient-last-seen', String(userid)] as const,
  lastDates: () => [...OUTREACH_KEYS.all, 'last-dates'] as const,
  lastInteractionDates: (programid: string) => [...OUTREACH_KEYS.all, 'last-interaction-dates', programid] as const,
} as const;
